import type { JiraBoardsApi } from '@ipen-portal/plugin-jira-boards-backend';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const jiraBoardsApiRef = createApiRef<
  TRPCOptionsProxy<JiraBoardsApi>
>().with({
  id: 'plugin.ipen.jira-boards.api',
});
